import { apiEmpleo } from "../../util/ApiEmpleo";

export type TContractEmployeeValuationHistoryItem = {
  id: string;
  createdAt: string;
  userFullname: string | null;
  oldValue: string | null;
  newValue: string | null;
};

export type TContractEmployeeValuationHistoryResponse = {
  items: TContractEmployeeValuationHistoryItem[];
};

const apiListContractEmployeeValuationHistory = async (
  contractId: string
): Promise<TContractEmployeeValuationHistoryResponse> => {
  const res: TContractEmployeeValuationHistoryResponse = await apiEmpleo.get(
    `contracts/${contractId}/employee-valuation-history`
  );

  return res;
};

export { apiListContractEmployeeValuationHistory };
